import StoredLayout from '../../layouts/StoredLayout'
import Dashboard from './Dashboard'
export default StoredLayout(Dashboard)
